import { useCallback, useContext, useState, createContext } from "react";
import { ReactSVG } from "react-svg";
import ToastSuccessImg from "@/assets/svg/toastSuccess.svg";
import ToastErrorImg from "@/assets/svg/error.svg";
import styled from "styled-components";

const ToastContext = createContext();

export default ToastContext;

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);  
  function showToast(opt) {
    if(toast) return
    setToast(opt);
    setTimeout(() => {
      setToast(null);
    }, 2700);
  }
  
  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {
        toast && <ToastWrapper>
          {toast.dir === 'top' && <div className="toast-inner toast-inner-top">
            <ReactSVG src={toast.type === 'success' ?  ToastSuccessImg : ToastErrorImg }  beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex') }}/>
            <div className="toast-text">
              {toast.text}
            </div>
          </div>}
          {toast.dir === 'center' && <div className="toast-inner toast-inner-center">
            <ReactSVG className="success" src={toast.type === 'success' ?  ToastSuccessImg : ToastErrorImg }  beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex') }}/>
            <div className="toast-text">
              {toast.text}
            </div>
          </div>}
        </ToastWrapper>
      }
    </ToastContext.Provider>
  );
}

const ToastWrapper = styled.div`
  .toast-inner{
    position: fixed;
    left: 50%;    
    transform: translateX(-50%);  
    z-index: 100000;
  }
  .toast-inner-top{
    display: flex;
    align-items: center;
    line-height: 62px;
    height: 62px;
    justify-content: center;
    background: #101010;
    border-radius: 8px;
    min-width: 338px;
    /* padding: 0 40px; */
    top: 76px;
    .toast-text{
      padding-left:12px;
      font-weight: 500;
      font-size: 22px;
    }
  }
  .toast-inner-center{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #000;
    border-radius: 8px;
    top: 30vh;
    width: 339px;
    height: 175px;
    color: #32DE86;
    font-size: 20px;
    .success svg{
      width: 34px;
      height:34px;
      margin-bottom:22px;
    }
    .toast-text{
      padding-left:12px;
      font-weight: 500;
      font-size: 20px;
    }
  }
`

export function useToastContext() {
  return useContext(ToastContext);
}
